module.exports = __webpack_public_path__ + "media/dog-profile-avatars/single-puppy-dog-51f5f232.svg";